<template>
    <div class="block-editor google-play-update-review-status">
        <section>
            <div class="title">{{ $t('auto.googlePlayUpdateReviewStatusReviewId') }}</div>
            <TiptapEditor placeholder="Google Play Review ID" :show-attributes="true" v-model="clone.reviewId" automation-mode />
            <small>{{ $t('auto.googlePlayUpdateReviewStatusDurumuGNcellenecekYorumunIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.googlePlayUpdateReviewStatusYeniDurum') }}</div>
            <a-select v-model="clone.status" class="classic-select" :placeholder="$t('auto.googlePlayUpdateReviewStatusDurumSeIniz')">
                <a-select-option value="new">{{ $t('auto.googlePlayUpdateReviewStatusYeniNew') }}</a-select-option>
                <a-select-option value="replied">{{ $t('auto.googlePlayUpdateReviewStatusYanTlandReplied') }}</a-select-option>
                <a-select-option value="resolved">{{ $t('auto.googlePlayUpdateReviewStatusZLdResolved') }}</a-select-option>
            </a-select>
        </section>
        <section>
            <div class="title">{{ $t('auto.googlePlayUpdateReviewStatusAtanacakTemsilciOpsiyonel') }}</div>
            <a-select v-model="clone.assigneeId" class="classic-select" :placeholder="$t('auto.googlePlayUpdateReviewStatusTemsilciSeIniz')" allow-clear>
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>{{ $t('auto.googlePlayUpdateReviewStatusYorumuBirTemsilciyeAtayabilirsiniz') }}</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "GooglePlayUpdateReviewStatus",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                reviewId: "",
                status: "new",
                assigneeId: null,
                ...this.value
            }),
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.google-play-update-review-status {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
    }
}
</style>
